import type { FiscalYear } from './api';

/**
 * Podpis roku obrotowego.
 *
 * Rok kalendarzowy opisuje jedna liczba i tak jest najczytelniej. Rok niekalendarzowy albo
 * wydłużony — a pierwszy rok wolno przedłużyć do osiemnastu miesięcy — jedną liczbą opisać się
 * nie da: rok od listopada 2025 do grudnia 2026 podpisany jako „2025" wyglądał tak, jakby roku
 * 2026 w ogóle nie było i nie dało się go wybrać.
 */
export function fiscalYearLabel(year: FiscalYear): string {
  const [odRok, odMies, odDzien] = year.startsOn.split('-');
  const [doRok, doMies, doDzien] = year.endsOn.split('-');
  const kalendarzowy = odMies === '01' && odDzien === '01' && doMies === '12' && doDzien === '31' && odRok === doRok;
  return kalendarzowy ? odRok : `${odMies}.${odRok} – ${doMies}.${doRok}`;
}
